export default __webpack_public_path__ + "static/media/image-1.28e0e45c.gif";